import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  min-height: ",
        "px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  margin-top: 24px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Spin } from "antd";
import { themeGet } from "@styled-system/theme-get";
const DefaultLoadingContainerWrapper = styled.div.withConfig({
    componentId: "sc-731c8572-0"
})(_templateObject());
const LoadingWrapper = styled.div.withConfig({
    componentId: "sc-731c8572-1"
})(_templateObject1(), (param)=>{
    let { height  } = param;
    return height ? height : 480;
});
const LoadingTitle = styled.p.withConfig({
    componentId: "sc-731c8572-2"
})(_templateObject2(), themeGet("text.2", "#1B1B29"));
export const DefaultLoadingContainer = (param)=>{
    let { title , height , showIndicator =true  } = param;
    return /*#__PURE__*/ _jsx(DefaultLoadingContainerWrapper, {
        children: /*#__PURE__*/ _jsxs(LoadingWrapper, {
            height: height,
            children: [
                /*#__PURE__*/ _jsx(Spin, {}),
                /*#__PURE__*/ _jsx(LoadingTitle, {
                    children: title
                })
            ]
        })
    });
};
